import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountRoutingModule } from './account-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountLoginComponent } from './account-login/account-login.component';
import { MatModule } from '../../core/material/mat.module';

@NgModule({
  imports: [
    CommonModule,
    AccountRoutingModule,
    ReactiveFormsModule,
    MatModule
  ],
  declarations: [
    AccountLoginComponent
  ]
})
export class AccountModule { }
